import { render } from "./Servicios.vue?vue&type=template&id=c47d071c&scoped=true"
import script from "./Servicios.vue?vue&type=script&lang=js"
export * from "./Servicios.vue?vue&type=script&lang=js"

import "./Servicios.vue?vue&type=style&index=0&id=c47d071c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47d071c"]])

export default __exports__